import './styles.css'
class TableScrollWithChildHorizontalVertical extends React.Component {
  shouldComponentUpdate (nextProps, nextState) {
    return false
  }

  componentDidMount () {
    let divScroll = $('.div-scroll')
    let tableScroll = $('.table-scroll')
    let tbodyInner = $('#tbodyinner')
    divScroll.scroll(this._handleScroll)
    tableScroll.scroll(this._handleTableScroll)
    tbodyInner.scroll(this._handleTbodyInner)
    this._handleWindowHeight()
  }

  componentWillMount = () => {
    window.addEventListener('resize', this._handleWindowHeight)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this._handleWindowHeight)
  }

  _contentHeightInterval = () => {
    return setInterval(function () {
      this._handleWindowHeight()
    }, 100)
  }

  _handleScroll = () => {
    let divScroll = $('.div-scroll')
    document.getElementById('tbodyinner').scrollLeft = divScroll.scrollLeft()
  }

  _handleTableScroll = () => {
    let tableScroll = $('.table-scroll')
    let widthDiv = tableScroll.scrollLeft() + tableScroll.width()
    document.getElementById('tbodyinner').style.width = widthDiv + 'px'
  }

  _handleTbodyInner = () => {
    let tbodyInner = $('#tbodyinner')
    document.getElementById('tbodydiv').scrollTop = tbodyInner.scrollTop()
  }

  _handleWindowHeight = () => {
    let bodyHeight = $(window).height()
    let contentHeight = bodyHeight - 226
    $('.div-scroll > .table-scroll tbody').css('max-height', contentHeight + 'px')
    $('.div-static > .table-static tbody').css('max-height', contentHeight + 'px')
    if ($('.div-scroll > .table-scroll tbody').css('max-height') === contentHeight + 'px' &&
      $('.report-table-outer').hasClass('element-non-mobi')) {
      clearInterval(this._contentHeightInterval)
    }
  }

  render () {
    let {
      parentHeader,
      parentBody,
      parentFoot,
      childHeaders,
      childBody,
      childFoot,
      parentClassName,
      childHeaderClassName,
      childBodyClassName,
      childFootClassName} = this.props

    return (
      <div id='report-sales-scroll' className='report-table-outer report-table-sales visible-md visible-lg'>
        <div className='div-static'>
          <table className='table table-static'>
            <thead className={parentClassName[0]}>
              <tr>
                <th>{parentHeader}</th>
              </tr>
            </thead>
            <tbody id='tbodydiv' className={parentClassName[1]}>
              { parentBody.map((val, pidx) => {
                return (<tr>
                  <td className={val.isParent ? 'parent' : 'child'}>
                    {val.name}
                  </td>
                </tr>
                )
              }
              )}
            </tbody>
            <tfoot className={parentClassName[2]}>
              <tr>
                <td className='text-left'><strong>{parentFoot}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className='div-scroll'>
          <table className='table table-scroll'>
            <thead>
              <tr>
                { childHeaders.map((val, pidx) => {
                  return <th className={childHeaderClassName[pidx]}>{val}</th>
                })
                }
              </tr>
            </thead>
            <tbody id='tbodyinner'>
              { childBody.map((val, pidx) => {
                let valObj = Object.values(val.data)
                return (<tr>
                  {valObj.map((value, pidx) => {
                    return <td className={`${childBodyClassName[pidx]} ${val.isParent ? 'parent' : 'child'}`}>{value}</td>
                  })}
                </tr>)
              })}
            </tbody>
            <tfoot id='tfootscroll'>
              <tr className='text-total'>
                {Object.values(childFoot).map((value, pidx) => {
                  return <td className={childFootClassName[pidx]}><b>{value}</b></td>
                })}
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    )
  }
}

export default TableScrollWithChildHorizontalVertical



// WEBPACK FOOTER //
// ./app/components/TableScrollWithChildHorizontalVertical/TableScrollWithChildHorizontalVertical.js